import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { all_routes } from "../router/all_routes";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import * as api from "../constant/NewAPI";
import Utils from "../constant/Utils";
import { Button } from "react-bootstrap";

const Footer = () => {
  const userName = localStorage.getItem('FullName');
  const roleId = localStorage.getItem('RoleId');
  let roleType = '';

  if (roleId == "8") {
    roleType = '/auth/tenvic-student';
  } else if (roleId == "7") {
    roleType = '/auth/tenvic-institution';
  } else {
    roleType = '/auth/tenvic-login';
  }

  if (localStorage.getItem('accessToken') == null) {
    window.location.href = roleType;
  }
  if (localStorage.getItem('accessToken') == '') {
    window.location.href = roleType;
  }

  const [lastActivity, setLastActivity] = useState(Date.now());
  const [accessTime, setAccessTime] = useState(parseInt(localStorage.getItem("accessConfigValue") || "60", 10));
  // const refreshTime = parseInt(localStorage.getItem("refreshConfigValue") || "60", 10);
  const logoutTimeData = parseInt(localStorage.getItem("closeConfigValue") || "60", 10);

  const refreshTime = parseInt(localStorage.getItem("refreshConfigValue") || "60", 10);
  const logoutTime = logoutTimeData * 1000; // 60 seconds
  const refreshInterval = refreshTime * 1000; // Refresh token every 55 seconds

  const activityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const refreshTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isUserActiveRef = useRef<boolean>(false);


  function refreshToken() {
    const serverUrl = api.refreshToken
    fetch(serverUrl, {
      method: "POST",
      headers: {
        "Authorization": 'Bearer ' + Utils.getAccessToken(),
        "Content-Type": "application/json"
      },
    })
      .then((response) => response.json())
      .then((result) => {
        console.log(result.data);
        localStorage.setItem("accessToken", result.data);
        setAccessTime(refreshTime);
      })
  }

  const logoutUser = async () => {
    try {
      localStorage.clear();
      window.location.href = roleType;
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  // Function to reset activity timer and refresh token if needed
  const resetActivityTimer = () => {
    isUserActiveRef.current = true; // Mark user as active

    // Clear previous logout timer
    if (activityTimeoutRef.current) {
      clearTimeout(activityTimeoutRef.current);
    }

    // Set new logout timer (user will be logged out if no activity for 60 seconds)
    activityTimeoutRef.current = setTimeout(() => {
      isUserActiveRef.current = false; // Mark user as inactive
      logoutUser();
    }, logoutTime);
  };

  useEffect(() => {
    // Function to handle token refresh cycle
    const refreshCycle = () => {
      if (isUserActiveRef.current) {
        // refreshToken();
        refreshTimeoutRef.current = setTimeout(refreshCycle, refreshInterval);
      }
    };

    // Start first token refresh after 59 seconds
    refreshTimeoutRef.current = setTimeout(refreshCycle, refreshInterval);

    // Start inactivity timer
    activityTimeoutRef.current = setTimeout(() => {
      isUserActiveRef.current = false;
      logoutUser();
    }, logoutTime);

    // Add event listeners to detect activity
    window.addEventListener("click", resetActivityTimer);
    window.addEventListener("mousemove", resetActivityTimer);
    window.addEventListener("keypress", resetActivityTimer);

    return () => {
      // Cleanup on unmount
      if (activityTimeoutRef.current) clearTimeout(activityTimeoutRef.current);
      if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);
      window.removeEventListener("click", resetActivityTimer);
      window.removeEventListener("mousemove", resetActivityTimer);
      window.removeEventListener("keypress", resetActivityTimer);
    };
  }, []);
  const routes = all_routes;

  const [selectedLanguage, setSelectedLanguage] = useState();
  const [selectedCurrency, setSelectedCurrency] = useState();

  const languageOptions = [
    { name: "English (US)" },
    { name: "UK" },
    { name: "Japan" },
  ];
  const currencyOptions = [{ name: "$ USD" }, { name: "$ Euro" }];

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <footer className="footer">
      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          {/* Copyright */}
          <div className="copyright">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="copyright-text">
                  <p className="mb-0">
                    © {new Date().getFullYear()}
                    TenvicSports - All rights reserved.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                {/* Copyright Menu */}
                <div className="dropdown-blk">
                  <ul className="navbar-nav selection-list">
                    <li className="nav-item dropdown">
                      <div className="lang-select">
                        <span className="select-icon">
                          <i className="feather-globe" />
                        </span>
                        <Dropdown
                          value={selectedLanguage}
                          onChange={(e) => setSelectedLanguage(e.value)}
                          // options={languageOptions}
                          optionLabel="name"
                          placeholder="English"
                          className="select footer-select"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                {/* /Copyright Menu */}
              </div>
            </div>
          </div>
          {/* /Copyright */}
        </div>
      </div>
      {/* /Footer Bottom */}
    </footer>
  );
};

export default Footer;
